import { Navigate } from 'react-router-dom';
import { getOrganizationType } from 'lib/organizationType';

/**
 * Root path: Assettech lands on dashboard; other orgs on pickups.
 */
export default function HomeRedirect() {
  const org = getOrganizationType();
  if (org === 'assettech') {
    return <Navigate to='/dashboard' replace />;
  }
  return <Navigate to='/pickups' replace />;
}
